<template>
  <div class="visualizeHome">
    <header class="header">
      <h1 class="title">创新项目智能应用</h1>
      <nav class="leftNav">
        <div
          class="leftNav-item"
          :class="{ 'leftNav-item_active': currentNav === 'mapView' }"
          @click="handleClick('mapView')"
        >
          无人机身份管理
        </div>
        <div
          class="leftNav-item"
          :class="{ 'leftNav-item_active': currentNav === 'controlCenter' }"
          @click="handleClick('')"
        >
          无人机导航识别
        </div>
      </nav>
      <nav class="rightNav">
        <div
          class="rightNav-item"
          :class="{ 'rightNav-item_active': currentNav === 'onceDiagram' }"
          @click="handleClick('')"
        >
          无人机导航诱骗
        </div>
        <div
          class="rightNav-item"
          :class="{ 'rightNav-item_active': currentNav === 'lineTopology' }"
          @click="handleClick('')"
        >
          剪线钳卡线器
        </div>
      </nav>
      <div class="info">
        <span class="back" @click="$router.back()">
          返回
        </span>
        <span class="info-date">{{ date }}</span>
        <span class="info-date">{{ weekDay }}</span>
      </div>
    </header>
    <div class="container">
      <component
        :is="currentComponent"
        @checkMore="checkMore"
        @back="handleBack"
        @changeNav="handleClick"
      ></component>
    </div>
  </div>
</template>

<script>
import { date } from "utils";
export default {
  name: "visualizeHome",
  data() {
    return {
      date: "", // 日期
      weekDay: "",
      currentComponent: "mapView",
      currentNav: "mapView",
      isFullScreen: false,
      dateTimer: null, // 用于更新日期的定时器
      devList:[],
    };
  },
  components: {
    mapView: () => import("./components/mapView/index.vue"),
    monitorData: () => import("./components/mapView/monitorData.vue"),
    controlCenter: () => import("./components/controlCenter/index.vue"),
    digitalTwin: () => import("./components/digitalTwin/index.vue"),
    onceDiagram: () => import("./components/onceDiagram/index.vue"),
    lineTopology: () => import("./components/lineTopology/index.vue"),
    photoVol: () => import("./components/photoVol/index.vue")
  },
  created() {
    let isFullScreen =
      document.fullscreenElement ||
      document.mozFullScreenElement ||
      document.webkitFullscreenElement ||
      document.fullScreen ||
      document.mozFullScreen ||
      document.webkitIsFullScreen;
    isFullScreen = !!isFullScreen;
    document.addEventListener("fullscreenchange", () => {
      this.isFullScreen = !isFullScreen;
    });
    document.addEventListener("mozfullscreenchange", () => {
      this.isFullScreen = !isFullScreen;
    });
    document.addEventListener("webkitfullscreenchange", () => {
      this.isFullScreen = !isFullScreen;
    });
    document.addEventListener("msfullscreenchange", () => {
      this.isFullScreen = !isFullScreen;
    });
  },
  mounted() {
    this.startDateTimer();
    this.enterfullscreen();
  },
  methods: {
    //进入全屏
    enterfullscreen() {
      let docElm = document.documentElement;
      if (!this.isFullScreen) {
        if (docElm.requestFullscreen) {
          //W3C
          docElm.requestFullscreen();
        } else if (docElm.mozRequestFullScreen) {
          //FireFox
          docElm.mozRequestFullScreen();
        } else if (docElm.webkitRequestFullScreen) {
          //Chrome等
          docElm.webkitRequestFullScreen();
        } else if (elem.msRequestFullscreen) {
          //IE11
          elem.msRequestFullscreen();
        }
      }
    },
    handleClick(val) {
      this.currentNav = val;
      this.currentComponent = val;
    },
    checkMore(val) {
      if (val === "mapView") {
        this.currentComponent = "monitorData";
      }
    },
    handleBack(val) {
      if (val === "mapView") {
        this.currentComponent = "mapView";
      }
    },
    updateDate() {
      const now = new Date();
      let dates = date(now);
      this.date = [dates.YY, dates.MM, dates.DD].join("-");
      this.weekDay = "星期" + "日一二三四五六".charAt(now.getDay());
    },
    startDateTimer() {
      // 清除可能存在的旧定时器
      if (this.dateTimer) {
        clearInterval(this.dateTimer);
      }

      // 立即更新一次日期
      this.updateDate();

      // 计算距离下一个0点的毫秒数
      const now = new Date();
      const tomorrow = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 1
      );
      const timeToMidnight = tomorrow - now;

      // 设置定时器，在下一个0点更新
      setTimeout(() => {
        this.updateDate();
        // 之后每24小时更新一次
        this.dateTimer = setInterval(() => {
          this.updateDate();
        }, 24 * 60 * 60 * 1000);
      }, timeToMidnight);
    },
  },
};
</script>

<style lang="less">
@import "./common.less";
html::-webkit-scrollbar {
  width: 0;
}
</style>

<style lang="less" scoped>
.visualizeHome {
  height: 100vh;
  background: url("./img/home/bg.png");
  background-size: cover;
  background-color: transparent;
  position: relative;

  .mark-fold {
    position: absolute;
    top: 11.59vh;
    right: 0;
    width: 0.24rem;
    height: 12.05vh;
    background-image: url("./img/jump_bgs.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s;

    span {
      text-align: center;
      display: inline-block;
      font-family: "FZLTZHK--GBK1-0";
      font-size: 1.3vh;
      color: #fff;
    }
  }

  .mark-unfold {
    position: absolute;
    top: 11.59vh;
    right: 0;
    width: 1.27rem;
    height: 12.14vh;
    background-image: url("./img/jump_bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    cursor: pointer;
    transition: all 0.3s;

    img {
      position: absolute;
      top: 1.2vh;
      left: 50%;
      transform: translateX(-50%);
      width: 1.01rem;
      height: auto;
    }

    span {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      display: inline-block;
      height: 3.98vh;
      line-height: 3.98vh;
      background-image: url("./img/jump.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      text-align: center;
      font-family: "FZLTZHK--GBK1-0";
      font-size: 1.48vh;
      letter-spacing: 0.02rem;
      color: #fff;
      text-shadow: 0 0 0.02rem #1b60b2, 0 0 0.02rem #1b60b2, 0 0 0.02rem #1b60b2,
        0 0 0.02rem #1b60b2;
    }
  }

  .header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
    height: 1.17rem;
    background-image: url("./img/home/head_bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;

    .header-left {
      position: absolute;
      left: 0.39rem;
      top: 0.04rem;
      display: flex;
      align-items: center;

      img {
        width: 0.37rem;
        height: 0.38rem;
      }

      .run-name {
        font-family: "MicrosoftYaHei-Bold";
        font-size: 0.14rem;
        color: rgba(255, 255, 255, 0.8);
      }

      .run-time {
        display: flex;
        align-items: center;

        &-num {
          font-family: "MicrosoftYaHei-Bold";
          font-weight: bold;
          font-size: 0.16rem;
          color: rgba(30, 236, 245, 0.8);
        }

        &-unit {
          margin: 0 0.04rem;
          font-family: "MicrosoftYaHei";
          font-size: 0.12rem;
          color: rgba(255, 255, 255, 0.8);
        }
      }
    }

    .title {
      margin-top: 0.1rem;
      font-family: "Alibaba-PuHuiTi-H";
      font-size: 0.36rem;
      font-weight: bold;
      color: #fff;
      letter-spacing: 0.03rem;
      background: linear-gradient(to bottom, #ffffff 20%, rgb(54, 163, 255));
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .leftNav {
      position: absolute;
      bottom: 0.12rem;
      left: 0.4rem;
      display: flex;
      align-items: center;

      &-item {
        width: 2.22rem;
        height: 0.39rem;
        background-image: url("./img/home/leftNav.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        padding-top: 0.02rem;
        display: flex;
        justify-content: center;
        font-family: MicrosoftYaHei;
        font-size: 0.18rem;
        color: #b1cff4;
        cursor: pointer;
      }

      .leftNav-item_active {
        background-image: url("./img/home/leftNav_actived.png");
        color: #fff;
      }
    }

    .rightNav {
      position: absolute;
      bottom: 0.12rem;
      right: 0.4rem;
      display: flex;
      align-items: center;

      &-item {
        width: 2.22rem;
        height: 0.39rem;
        background-image: url("./img/home/rightNav.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        padding-top: 0.02rem;
        display: flex;
        justify-content: center;
        font-family: MicrosoftYaHei;
        font-size: 0.18rem;
        color: #b1cff4;
        cursor: pointer;
      }

      .rightNav-item_active {
        background-image: url("./img/home/rightNav_actived.png");
        color: #fff;
      }
    }

    .info {
      position: absolute;
      right: 0.4rem;
      top: 0.16rem;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        font-size: 0.14rem;
        font-family: "MicrosoftYaHei-Bold";
        color: #fff;
        opacity: 0.8;

        &:last-child {
          margin-left: 0.2rem;
        }
      }
    }
  }
  .back {
    width: 0.6rem;
    background-image: url("./img/home/rightNav.png");
    color: #fff;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding-top: 0.02rem;
    display: flex;
    justify-content: center;
    font-family: MicrosoftYaHei;
    font-size: 0.18rem;
    cursor: pointer;
  }
  .container {
    height: 100%;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/visualize/visualizeWrj/visualizeHome.vue